import { makeAutoObservable } from "mobx"
import { GenderType, PlanType } from "./index.types"

const Params = new URL(window.location.href).searchParams
class FormStore {
  calc_planType: PlanType = "Guaranteed" // #guarantMarket
  calc_gender: GenderType = "Male" // #gender
  calc_dob: string = "" // #dob
  calc_age: number = -3 // #age
  calc_days: number = 0
  calc_mobile: number | string = "" // #MobileNo
  calc_email: string = "" // #EmailId
  calc_ndncCB: boolean = true // #TRAI_FLAG

  constructor() {
    makeAutoObservable(this)
  }

  setCalcPlanType = (data: PlanType) => (this.calc_planType = data)
  setCalcGender = (data: GenderType) => (this.calc_gender = data)
  setCalcDOB = (data: string) => (this.calc_dob = data)
  setCalcAge = (data: number) => (this.calc_age = data)
  setCalcDays = (data: number) => (this.calc_days = data)
  setCalcMobile = (data: string | number) => (this.calc_mobile = data)
  setCalcEmail = (data: string) => (this.calc_email = data)
  setCalcNDNCCB = (data: boolean) => (this.calc_ndncCB = data)
}

export default new FormStore()
